import objectFitImages from "object-fit-images"

import collapse from "./utils/collapse"
import print from "./utils/print"

import windowResize from "./components/window-resize.js"
import desktopNav from "./components/desktop-nav.js"
import accordion from "./components/accordion.js"
import mobileFriendlyTables from "./components/mobile-friendly-tables"
import officesSelector from "./components/offices-selector"
import officesMap from "./components/offices.js"
import contentReveal from "./components/content-reveal"
import mobileCarousel from "./components/mobile-carousel"
import addressAutocomplete from "./components/address-autocomplete"
import dropdown from "./components/dropdown"
import ElementTopTasks from "./components/element-top-tasks"
import formfield from "./components/formfield"
import ElementQuickLinks from "./components/element-quick-links"
import sidebar from "./components/sidebar"
import sitemap from "./components/sitemap"
import MobileMenu from "./components/mobile-nav"
import Focus from "./components/focus"
import Donation from "./components/donation"
import GTMDonationEvents from "./components/gtm-donation-events"
import DonationReason from "./components/donation-reason"
import Announcement from "./components/announcement"
import Carousel from "./components/carousel"
import Shop from "./components/shop"
import FeedbackForm from "./components/feedback-form"
import MicrositeNav from "./components/microsite-nav"

// Set Axios defaults
const axios = require("axios")
axios.defaults.headers.common["x-requested-with"] = "XMLHttpRequest"

document.addEventListener("DOMContentLoaded", function() {
  objectFitImages()

  new Focus()
  new windowResize()
  new desktopNav()
  new accordion()
  new mobileFriendlyTables()
  new officesSelector()
  new officesMap()
  new contentReveal()
  new mobileCarousel()
  new dropdown()
  new ElementTopTasks()
  new formfield()
  new ElementQuickLinks()
  new sidebar()
  new sitemap()
  new addressAutocomplete()
  new MobileMenu()
  new Donation()
  new DonationReason()
  new Announcement()
  new Shop()
  new FeedbackForm()
  new MicrositeNav()

  print()
  collapse()
  Carousel()

  if (document.body.classList.contains("DonationPage")) {
    new GTMDonationEvents()
  } else {
    GTMDonationEvents.Dropout()
  }
})
